module.exports = __webpack_public_path__ + "static/media/construction_sanitation.0aa98ba4.png";